<template>
    <div class="p-1 mt-2">
      <div class="row">
        <div class="card">
          <div class="card-header">
            {{ t.custom_reseller_panel.account_in_out }}
          </div>
          <DateFilter :startDate="start" :endDate="end"></DateFilter>
          <div class="card-block p-0">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                <tr>
                  <th>Casino GGR</th>
                  <th>Casino Bet</th>
                  <th>Casino {{ t.betting.title.earnings }}</th>
                  <th>{{ t.betting.title.stake }}</th>
                  <th>{{ t.betting.title.earnings }}</th>
                  <th>Sport GGR</th>
                  <th>{{ t.total }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="loading">
                  <td colspan="4" align="center">
                    <Loading></Loading>
                  </td>
                </tr>
                <template v-if="!loading">
                  <tr v-if="data.length < 1">
                    <td colspan="4" align="center">{{ t.error.notfound_content_list }}</td>
                  </tr>
                  <tr v-for="d in data.bet_report">
                    <td>
                    <span class="amount">
                        {{ d.casino_profit | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                        {{ d.wager | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                      {{ d.won | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                      {{ d.bet_wager | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                      {{ d.bet_earnings | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                      {{ d.bet_profit | toMoney(session.currency)  }}
                    </span>
                    </td>
                    <td>
                    <span class="amount">
                      {{ (( parseFloat(general.casino_profit) + parseFloat(general.bet_profit)).toFixed(2)) | toMoney(session.currency) }}
                    </span>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <sweet-modal width="100%" ref="cp" v-on:close="closeCasinoProviderReport()">
          <ProviderCasino v-if="$route.query.casino_report > 0" :id="$route.query.casino_report" :start="start" :end="end"/>
      </sweet-modal>
    </div>
  </template>
  
  <script>
  import DateFilter from "../DateFilter";
  import Loading from "../Loading";
  import ProviderCasino from "../views/ProviderCasino";
  export default {
    name: "AccountCasino",
    components: {Loading, DateFilter, ProviderCasino},
    props: ['id'],
    data() {
      return {
        session: window.session,
        start: moment().startOf('week').add(1, 'days').format("DD MMMM YYYY ddd"),
        end: moment(new Date()).format("DD MMMM YYYY ddd"),
        data: [],
        general: [],
        loading: false,
        t: this.$root.t
      }
    },
    mounted() {
      this.fetchTransactions(this.start, this.end, false);
    },
    watch: {
      '$route.query.casino_report' () {
        if(this.$route.query.casino_report > 0)
          this.$refs.cp.open()
      },
      
    },
    methods: {
      closeCasinoProviderReport () {
          this.$router.back()
      },
      fetchTransactions(from, to){
        this.start = from;
        this.end = to;
        this.loading = true;
        this.$http.get(api + 'api/v1/reports/user_giro/'+this.id, {
          params: {
            direction: 'desc',
            start: from ? from : moment(moment(new Date()).format()).add(-2, 'd').format('YYYY-MM-DD'),
            end: to ? to : moment().add(+1, 'd').format("YYYY-MM-DD")
          }
        })
        .then(response => {
          this.general = response.body.result.data
          this.data = response.body.result.data;
          this.loading = false
        }, response => {
          this.loading = false
        })
      }
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/views/AccountUser.vue